import { type CreateOrderError, CREATE_ORDER_ERROR } from '../model'

export const CREATE_ORDER_ERROR_I18N_KEYS: Record<CreateOrderError, string> = {
  [CREATE_ORDER_ERROR.generic]: 'shop_order_create_error',
  [CREATE_ORDER_ERROR.outOfStock]: 'shop_cart_some_items_out_of_stock',
  [CREATE_ORDER_ERROR.skuNotFound]: 'shop_order_sku_not_found',
  [CREATE_ORDER_ERROR.skuZeroQuantity]: 'shop_order_not_enough_stock',
  [CREATE_ORDER_ERROR.notEnoughCoins]: 'shop_order_not_enough_coins',
  [CREATE_ORDER_ERROR.wrongAmount]: 'shop_order_wrong_amount',
  [CREATE_ORDER_ERROR.noActiveBillingPeriod]: 'shop_order_no_active_billing_period',
  [CREATE_ORDER_ERROR.productNotFound]: 'shop_order_product_not_found',
  [CREATE_ORDER_ERROR.emptyCart]: 'shop_order_empty_cart',
  [CREATE_ORDER_ERROR.invalidAddress]: 'shop_order_invalid_address',
  [CREATE_ORDER_ERROR.invalidPostalCode]: 'shop_order_invalid_postal_code',
  [CREATE_ORDER_ERROR.invalidPhone]: 'shop_order_invalid_phone',
  [CREATE_ORDER_ERROR.invalidEmail]: 'shop_order_invalid_email',
  [CREATE_ORDER_ERROR.invalidQuantity]: 'shop_order_invalid_quantity',
  [CREATE_ORDER_ERROR.requiredField]: 'shop_order_required_field',
}

const FORM_VALIDATION_ERRORS: CreateOrderError[] = [
  CREATE_ORDER_ERROR.invalidPhone,
  CREATE_ORDER_ERROR.invalidEmail,
  CREATE_ORDER_ERROR.invalidAddress,
  CREATE_ORDER_ERROR.invalidPostalCode,
  CREATE_ORDER_ERROR.invalidQuantity,
  CREATE_ORDER_ERROR.requiredField,
]

export const shouldKeepOrderDialogOpen = (error: CreateOrderError): boolean => FORM_VALIDATION_ERRORS.includes(error)
